<template>
  <div class="chat-call-time-form">
    <div class="select-wrap">
      <div class="select-field">
        <label for="date-select">When's best to call?</label>
        <select
          id="date-select"
          v-model="date"
          class="mic-input__input cdc-input__label"
        >
          <option
            v-for="option of voipDateOptions"
            :key="option.label"
            :value="option.value"
          >
            {{ option.label3 }}
          </option>
        </select>
      </div>

      <div class="select-field--time">
        <label for="time-select">Choose a time</label>
        <select
          id="time-select"
          v-model="voipTime"
          class="mic-input__input"
        >
          <option
            v-for="option of voipTimeOptions"
            :key="option.label"
            :value="option.value"
          >
            {{ option.label }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import ScheduleTimeAndDateOptions from '../mixins/ScheduleTimeAndDateOptions'
import IsOfficeOpen from '../mixins/IsOfficeOpen'
import { mapActions } from 'vuex'

export default {
  name: 'CDCCallTimeForm',

  mixins: [ScheduleTimeAndDateOptions, IsOfficeOpen],

  data () {
    return {
      voipTime: null
    }
  },

  computed: {
    voipDateOptions () {
      if (new Date().toString().startsWith(this.dateOptions[0].label)) {
        return [
          {
            label: this.dateOptions[0].label,
            label2: this.dateOptions[0].label2,
            label3: 'Today',
            value: this.dateOptions[0].value
          },
          ...this.dateOptions.slice(1)
        ]
      }
      return this.dateOptions
    },
    voipTimeOptions () {
      if (!!this.date && this.isOfficeOpen() && new Date().toDateString() === this.date.toDateString()) {
        return [
          {
            label: 'Straight away',
            value: null
          },
          ...this.timeOptions
        ]
      }
      return this.timeOptions
    }
  },

  watch: {
    voipTimeOptions () {
      this.voipTime = this.voipTimeOptions[0].value
    },
    voipTime () { this.actionUpdateCallBackData({ contactDateTime: this.voipTime }) }
  },

  methods: {
    ...mapActions(['actionUpdateCallBackData'])
  }
}
</script>

<style lang="scss" scoped>
.chat-call-time-form {
  display: block;
}

.select-field {
  width: 202px;
  display: inline-block;
  margin-bottom: $spacing-20;
  color: $text-color;
  font-size: 14px;

  &--time {
      @extend .select-field;

      @media(min-width: 800px) {
          width: 160px;
      }
  }

  @media (max-width: $screen-md) {
    width: 100%;
  }

  &:first-child {
    margin-right: $spacing-18;
  }

  label {
    display: block;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 20px;
    font-weight: bold;
    text-align: left;
    color: $bionic-navy;
  }

  select {
    display: block;
    width: 100%;
    appearance: none;
    border-radius: $border-radius-small;
    background-color: $white;
    border: 1px solid $chat-bot-select-border;
    background-image: url(../assets/icons/select-arrow.svg);
    background-size: $spacing-16;
    background-repeat: no-repeat;
    background-position: 95% 50%;
    height: 56px;
    padding-left: $spacing-16;
  }
}

.select-field {
  position: relative;
}

.form-footer {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: center;

  .return-link {
    font-size: 16px;
    text-decoration: underline;
    cursor: pointer;
  }

  @media (max-width: $screen-md) {
    flex-direction: column;

    .submit-btn {
      min-width: initial;
      width: 100%;
      margin-bottom: $spacing-12;
    }
  }
}
</style>
